import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Geofence, GeofenceCreateInput, GeofenceUpdateInput } from '@models/geofence.model';
import { geofenceService } from '@services/geofence';
import { GEOFENCES_QUERY_KEY } from './useGeofences';

const invalidateAllGeofenceQueries = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: GEOFENCES_QUERY_KEY });
};

export const useCreateGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation<Geofence, Error, GeofenceCreateInput>({
    mutationFn: (input) => geofenceService.createGeofence(input),
    onSuccess: () => invalidateAllGeofenceQueries(queryClient),
  });
};

export const useUpdateGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation<Geofence, Error, GeofenceUpdateInput>({
    mutationFn: (input) => geofenceService.updateGeofence(input),
    onSuccess: () => invalidateAllGeofenceQueries(queryClient),
  });
};

export const useSetGeofenceActive = () => {
  const queryClient = useQueryClient();

  return useMutation<Geofence, Error, { geofenceId: string; isActive: boolean }>({
    mutationFn: ({ geofenceId, isActive }) =>
      geofenceService.setGeofenceActive(geofenceId, isActive),
    onSuccess: () => invalidateAllGeofenceQueries(queryClient),
  });
};

export const useDeleteGeofence = () => {
  const queryClient = useQueryClient();

  return useMutation<{ affected: number }, Error, string>({
    mutationFn: (geofenceId) => geofenceService.deleteGeofence(geofenceId),
    onSuccess: () => invalidateAllGeofenceQueries(queryClient),
  });
};
